<!doctype html>
<html lang="zh-CN" data-xiaocai-startup-state="booting">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0, viewport-fit=cover" />
    <meta name="theme-color" content="#f5f7fb" />
    <script>
      document.documentElement.dataset.xiaocaiStartupStartedAt = String(Date.now())
    </script>
    <link rel="icon" type="image/svg+xml" href="/assets/logo-light.svg" />
    <link rel="preload" as="image" href="/assets/logo-xiaocai.svg" type="image/svg+xml" />
    <title>小采 - 采购助手</title>
    <style>
      html,
      body {
        height: 100%;
        margin: 0;
        min-height: 100%;
        background: #f5f7fb;
      }

      #root {
        min-height: 100%;
        opacity: 0;
        transform: translate3d(0, 8px, 0);
        transition: opacity 360ms ease, transform 420ms cubic-bezier(0.22, 1, 0.36, 1);
      }

      html[data-xiaocai-startup-state='ready'] #root,
      html[data-xiaocai-startup-state='dismissed'] #root {
        opacity: 1;
        transform: translate3d(0, 0, 0);
      }

      .xiaocai-startup-screen {
        align-items: center;
        background:
          radial-gradient(circle at 50% 42%, rgba(139, 92, 246, 0.08), transparent 30%),
          #f5f7fb;
        box-sizing: border-box;
        color: #172033;
        display: grid;
        font-family: "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", system-ui, -apple-system, sans-serif;
        inset: 0;
        justify-items: center;
        min-height: 100vh;
        min-height: 100svh;
        min-height: 100dvh;
        padding: calc(env(safe-area-inset-top, 0px) + 24px)
          calc(env(safe-area-inset-right, 0px) + 24px)
          calc(env(safe-area-inset-bottom, 0px) + 24px)
          calc(env(safe-area-inset-left, 0px) + 24px);
        position: fixed;
        transition:
          opacity 360ms cubic-bezier(0.22, 1, 0.36, 1),
          visibility 360ms ease;
        z-index: 2147483647;
      }

      .xiaocai-startup-screen[hidden] {
        display: none;
      }

      .xiaocai-startup-screen.is-exiting {
        opacity: 0;
        pointer-events: none;
        visibility: hidden;
      }

      .xiaocai-startup-screen__fallback,
      .xiaocai-startup-screen__react-root {
        grid-area: 1 / 1;
        height: 100%;
        width: 100%;
      }

      .xiaocai-startup-screen__react-root {
        display: none;
      }

      .xiaocai-startup-screen.is-react-owned .xiaocai-startup-screen__fallback {
        display: none;
      }

      .xiaocai-startup-screen.is-react-owned .xiaocai-startup-screen__react-root {
        display: block;
      }

      .xiaocai-startup-screen__surface {
        align-items: center;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        height: 100%;
        justify-content: center;
        text-align: center;
        width: 100%;
      }

      .xiaocai-startup-screen__logo {
        animation: xiaocai-logo-enter 560ms cubic-bezier(0.22, 1, 0.36, 1) both;
        display: block;
        height: clamp(76px, 7vw, 96px);
        width: clamp(76px, 7vw, 96px);
      }

      .xiaocai-startup-screen__welcome {
        color: #334155;
        font-size: 14px;
        font-weight: 600;
        letter-spacing: 0.08em;
        margin: 22px 0 0;
      }

      .xiaocai-startup-screen__status {
        align-items: center;
        color: #7c6f9f;
        display: flex;
        font-size: 12px;
        gap: 8px;
        line-height: 1.5;
        margin: 10px 0 0;
        min-height: 20px;
      }

      .xiaocai-startup-screen__message {
        animation: xiaocai-status-enter 240ms ease both;
      }

      .xiaocai-startup-screen__dots {
        display: inline-flex;
        gap: 3px;
      }

      .xiaocai-startup-screen__dots span {
        animation: xiaocai-loading-dot 1.2s ease-in-out infinite;
        background: #8b5cf6;
        border-radius: 999px;
        height: 4px;
        opacity: 0.3;
        width: 4px;
      }

      .xiaocai-startup-screen__dots span:nth-child(2) {
        animation-delay: 160ms;
      }

      .xiaocai-startup-screen__dots span:nth-child(3) {
        animation-delay: 320ms;
      }

      .xiaocai-startup-screen__retry {
        background: #8b5cf6;
        border: 0;
        border-radius: 999px;
        color: #ffffff;
        cursor: pointer;
        font: inherit;
        font-size: 13px;
        font-weight: 600;
        margin-top: 18px;
        padding: 9px 20px;
      }

      .xiaocai-startup-screen.is-blocked .xiaocai-startup-screen__dots,
      .xiaocai-startup-screen.is-error .xiaocai-startup-screen__dots {
        display: none;
      }

      @keyframes xiaocai-logo-enter {
        from { opacity: 0; transform: translate3d(0, 10px, 0) scale(0.94); }
        to { opacity: 1; transform: translate3d(0, 0, 0) scale(1); }
      }

      @keyframes xiaocai-loading-dot {
        0%, 80%, 100% { opacity: 0.25; transform: translateY(0); }
        40% { opacity: 1; transform: translateY(-2px); }
      }

      @keyframes xiaocai-status-enter {
        from { opacity: 0; transform: translate3d(0, 3px, 0); }
        to { opacity: 1; transform: translate3d(0, 0, 0); }
      }

      @media (prefers-reduced-motion: reduce) {
        #root,
        .xiaocai-startup-screen {
          transition-duration: 1ms;
        }

        .xiaocai-startup-screen__logo,
        .xiaocai-startup-screen__message,
        .xiaocai-startup-screen__dots span {
          animation: none;
        }
      }
    </style>
  </head>
  <body>
    <div class="xiaocai-startup-screen" id="xiaocai-startup-screen">
      <div class="xiaocai-startup-screen__fallback">
        <section class="xiaocai-startup-screen__surface" role="status" aria-live="polite">
          <img class="xiaocai-startup-screen__logo" src="/assets/logo-xiaocai.svg" alt="小采" />
          <p class="xiaocai-startup-screen__welcome">XIAOCAI</p>
          <p class="xiaocai-startup-screen__status">
            <span class="xiaocai-startup-screen__message" data-xiaocai-startup-message>正在验证身份</span>
            <span class="xiaocai-startup-screen__dots" aria-hidden="true"><span></span><span></span><span></span></span>
          </p>
        </section>
      </div>
      <div class="xiaocai-startup-screen__react-root" id="xiaocai-startup-react-root"></div>
    </div>
    <div id="root"></div>
    <script>
      (() => {
        const searchParams = new URLSearchParams(window.location.search)
        const authParamNames = ['credential', 'login_ticket', 'ticket', 'token', 'sso_ticket', 'auth_code', 'host_token', 'wechat_code']
        const hasEntryCredential = authParamNames.some((name) => (searchParams.get(name) || '').trim().length > 0)
        const hasSessionMarker = (() => {
          try {
            const hasSessionStorageMarker = window.sessionStorage?.getItem('xiaocai_session_active') === 'true'
            const hasCookieMarker = document.cookie
              .split(';')
              .map((item) => item.trim())
              .some((item) => item === 'xiaocai_session_active=1')
            return hasSessionStorageMarker || hasCookieMarker
          } catch {
            return false
          }
        })()
        if (hasEntryCredential || hasSessionMarker) {
          return
        }
        document.documentElement.dataset.xiaocaiEntryBlocked = 'true'
        document.documentElement.dataset.xiaocaiStartupState = 'blocked'
        const blocker = document.getElementById('xiaocai-startup-screen')
        blocker?.classList.add('is-blocked')
        const message = blocker?.querySelector('[data-xiaocai-startup-message]')
        if (message) {
          message.textContent = '请从采购中国小程序进入云鹤AI服务'
        }
      })()
    </script>
    <script type="module" src="/src/main.tsx"></script>
  </body>
</html>
